import * as React from "react";
import { OfficeHostType } from "../interfaces/index";
import { Icon, PrimaryButton, TextField } from "office-ui-fabric-react";
export var MetadataPanel = function MetadataPanel(props) {
  var _a = React.useState(),
      title = _a[0],
      setTitle = _a[1];

  var suffix = "";

  switch (props.template.hostType) {
    case OfficeHostType.Word:
      suffix = ".docx";
      break;

    case OfficeHostType.Excel:
      suffix = ".xlsx";
      break;

    case OfficeHostType.PowerPoint:
      suffix = ".pptx";
      break;
  }

  var submitTemplate = function submitTemplate() {
    if (title == "" || title == undefined) return false;
    var target = {
      id: "",
      title: title || props.template.title,
      name: title + suffix || props.template.name + suffix,
      hostType: props.template.hostType,
      parentReference: {
        driveId: props.targetDriveId,
        siteId: props.targetSiteId,
        folderId: props.targetFolderId
      }
    };
    props.copyFile(props.template, target);
    return true;
  };

  var docPreview = React.createElement("div", null, props.strings.NoPreviewFound);

  if (props.template.docPreviewUrl) {
    docPreview = React.createElement("iframe", {
      title: props.template.title,
      src: props.template.docPreviewUrl,
      height: "100%",
      width: "100%"
    });
  } else if (props.template.imageURL) {
    docPreview = React.createElement("img", {
      src: props.template.imageURL,
      title: props.template.title
    });
  }

  return React.createElement("div", null, React.createElement("div", {
    className: "subTitle"
  }, React.createElement(Icon, {
    iconName: "ChevronLeftSmall",
    title: props.strings.Back,
    onClick: props.cancel,
    className: "backIcon"
  }), React.createElement("span", null, props.strings.EnterMetadata)), React.createElement("div", {
    className: "metadata"
  }, React.createElement(TextField, {
    label: props.strings.FilenameHelp,
    required: true,
    "aria-required": "true",
    suffix: suffix,
    onChange: function onChange(e, value) {
      setTitle(value);
    }
  }), React.createElement("br", null), React.createElement("div", {
    className: "buttonContainer"
  }, React.createElement(PrimaryButton, {
    text: props.strings.Next,
    onClick: submitTemplate,
    disabled: !title
  }))), React.createElement("div", {
    className: "preview"
  }, React.createElement("div", {
    className: "previewTitle"
  }, props.strings.Preview.replace("{filename}", props.template.title)), React.createElement("div", {
    className: "previewContainer"
  }, docPreview), React.createElement("div", {
    className: "description"
  }, props.template.description)), React.createElement("div", {
    style: {
      clear: "both"
    }
  }));
};